import { Box, Button, Card, CardContent, Stack } from '@mui/material';
import React from 'react';

export default function HomeActionButtons({
  isMobile,
  onCreateCampaign,
  onAddKeyword,
  onManageContacts,
}: {
  isMobile: boolean;
  onCreateCampaign: () => void;
  onAddKeyword: () => void;
  onManageContacts: () => void;
}) {
  if (isMobile) {
    return (
      <Box my={2}>
        <Stack direction="column" spacing={1}>
          <Button size="medium" onClick={onCreateCampaign} variant="contained" fullWidth>
            Create Campaign
          </Button>
          <Button size="medium" onClick={onAddKeyword} variant="contained" fullWidth>
            Add Keyword
          </Button>
          <Button size="medium" onClick={onManageContacts} variant="contained" fullWidth>
            Manage Contacts
          </Button>
        </Stack>
      </Box>
    );
  }

  return (
    <>
      <Box width="1%"></Box>
      <Card variant="outlined" sx={{ mt: 2.5, width: '24%' }}>
        <CardContent
          sx={{
            height: '100%',
            display: 'flex',
            minHeight: 176,
            alignItems: 'center',
            justifyContent: 'center',
            mt: -2.5,
            pb: '0px !important',
            pl: 0,
            pr: 0,
          }}
        >
          <Stack direction="column" justifyContent="center" spacing={1.25} width="100%" px={2.5} pt={1.25}>
            <Button size="small" onClick={onCreateCampaign} variant="contained">
              Create Campaign
            </Button>
            <Button size="small" onClick={onAddKeyword} variant="contained">
              Add Keyword
            </Button>
            <Button size="small" onClick={onManageContacts} variant="contained">
              Manage Contacts
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}
